<script>
  import lodash from 'lodash';
  import TableCellBase from './TableCellBase.vue';

  export default {
    name: 'TableCellNumVialsMixedPerTech',
    extends: TableCellBase,
    data() {
      return {
        fields: [
          'scit_vials_total',
          'slit_vials_total',
        ],
      };
    },
    computed: {
      actualValueRaw() {
        const vials = lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.monthObj[field])
        }, 0);
        return this.round(this.getRatio(vials, this.monthObj['num_techs']), 2);
      },
    },
  };
</script>
